import navMenuItems from '@/navigation/horizontal'

export function filtrarMenuPorPermisos(permisos = {}, userData = {}) {
  const nombreUsuario = (userData.nombre || '').trim().toLowerCase()

  const puedeVerItem = (item) => {
    const titulo = (item.title || '').trim().toLowerCase()

    if (titulo === 'usuarios' || titulo.includes('usuarios')) {
      return ['guille', 'pablo'].includes(nombreUsuario)
    }

    if (!permisos || Object.keys(permisos).length === 0) {
      return true
    }

    return permisos[item.route] === true
  }

  return navMenuItems
    .map(grupo => {
      if (Array.isArray(grupo.children)) {
        const childrenFiltrados = grupo.children.filter(puedeVerItem)
        if (childrenFiltrados.length === 0) return null
        return { ...grupo, children: childrenFiltrados }
      }

      return puedeVerItem(grupo) ? grupo : null
    })
    .filter(Boolean)
}